module.exports = __webpack_public_path__ + "static/media/cancel.94b47e38.png";